import {ErrorBase} from '../../../../../error';

export class OpenIdError extends ErrorBase {
}
